(function () {
  // Cache the NodeList once
  const testimonialSections = Array.from(document.querySelectorAll('.bd-collection-testimonial-section'));

  // Initialize one testimonial swiper
  function initCollectionTestimonial(section) {
    const carousel = section.querySelector('.swiper-collection-testimonial');
    const scrollbar = section.querySelector('.swiper-scrollbar');
    if (!carousel || carousel.classList.contains('swiper-initialized')) return;

    if (!scrollbar) return;


    const swiperInstance = new Swiper(carousel, {
      loop: true,
      spaceBetween: 0,
      slidesPerView: 1,
      scrollbar: {
        el: carousel.querySelector('.swiper-scrollbar'),
      },
    });

    // store instance reference for cleanup
    carousel.swiperInstance = swiperInstance;
  }

  // Destroy one testimonial swiper
  function destroyCollectionTestimonial(section) {
    const carousel = section.querySelector('.swiper-collection-testimonial');
    if (carousel?.swiperInstance) {
      carousel.swiperInstance.destroy(true, true);
      carousel.swiperInstance = null;
    }
  }

  // Initialize all
  function setupCollectionTestimonial() {
    testimonialSections.forEach(section => {
      const carousel = section.querySelector('.swiper-collection-testimonial');
      if (carousel && !carousel.classList.contains('swiper-initialized')) {
        initCollectionTestimonial(section);
      }
    });
  }

  // Initialize when DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCollectionTestimonial);
  } else {
    setupCollectionTestimonial();
  }

  // Throttled resize (uses cached NodeList)


  var resizeRunning = false;

  window.addEventListener('resize', () => {
    if (resizeRunning) return;
    resizeRunning = true;

    requestAnimationFrame(() => {
      setupCollectionTestimonial();
      resizeRunning = false;
    });
  });


  // Handle Shopify section reloads
  document.addEventListener('shopify:section:load', e => {
    const section = document.querySelector(`.bd-collection-testimonial-section[data-section-id="${e.detail.sectionId}"]`);
    if (section) {
      const waitForDOM = () => {
        // Only init when section is actually painted and visible
        if (document.body.contains(section)) {
          requestAnimationFrame(() => initCollectionTestimonial(section));
        } else {
          requestAnimationFrame(waitForDOM);
        }
      };
      requestAnimationFrame(waitForDOM);
    }
    // if (section) setTimeout(() => initCollectionTestimonial(section), 300);
  });

  document.addEventListener('shopify:section:unload', e => {
    const section = document.querySelector(`.bd-collection-testimonial-section[data-section-id="${e.detail.sectionId}"]`);
    if (section) destroyCollectionTestimonial(section);
  });

  document.addEventListener('shopify:theme-settings:updated', () => {
    setupCollectionTestimonial();
  });
})();
